
import React, {useEffect, useState} from 'react';
import {accommodation_views} from '../../../service/accommodation'
import rombus from '../../../media/rombus.gif'

const AccTopLists = ({client_id, agent_id, prod_type=null, date_from=null, date_to=null, title=null, max_items=10, token, timeout=1000}) => {

    const [listData, set_list_data] = useState(null);

    const  popd = (client_id, agent_id, date_from, date_to, prod_type) => {

        setTimeout(() => {
            accommodation_views(client_id, agent_id, null, null, date_from, date_to, max_items, prod_type, token).then((d) => {
            if(d != null){
                set_list_data(d)
            }
            });       
        }, (timeout));

    }
    

    let cTitle = 'Top Viewed Accommodations';
    if(title != null){
        cTitle = title;
    }

    useEffect(() =>{
        set_list_data(null);
        popd(client_id, agent_id, date_from, date_to, prod_type);
    }, [client_id, agent_id, date_from, date_to, prod_type])

    if(listData == null){
        return <>
            <div className='countBlock'>
                <div className='countBlockTitle'>
                    {cTitle}
                </div>
                <div className='countBlockContent'>
                    <div style={{justifyContent: 'center'}}>
                            <img src={rombus}></img>
                    </div>
                </div>
            </div>
        </>
    }

    const lItems = [];
    for(const x of listData){

        let strName = x.name;
        if(x.name.length > 31){
            strName = x.name.substring(0, 31) + '...'
        }
        lItems.push(<li>{strName}</li>);
    }

    return (<div className='listBlock'>
        <div className='listBlockTitle'>
            {cTitle}
        </div>
        <div className='listBlockContent'>
            <ul>
                {lItems}
            </ul>

        </div>
    </div>)

}

export default AccTopLists
